import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Enthusiastic Frontend Developer with 2.5 years of experience specializing in Angular and building responsive, scalable, and high-performance web applications.
              <br />
              <br />I am proficient in languages like
              <i>
                <b className="purple"> JavaScript, TypeScript, Dart, and HTML5/CSS3. </b>
              </i>
              <br />
              <br />
              My field of interest includes building modern &nbsp;
              <i>
                <b className="purple">Web Applications and Mobile Apps </b> and
                also working with{" "}
                <b className="purple">
                  Cloud Technologies like AWS.
                </b>
              </i>
              <br />
              <br />
              I love developing products with <b className="purple">Angular</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js, Node.js, and Flutter</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/NikhilRathod-1305"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/nikhilrathod1305"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
